(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-card-wrapper/assets/javascripts/casino-card-wrapper.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-card-wrapper/assets/javascripts/casino-card-wrapper.js');

'use strict';

const {
  Card
} = svs.ui.ReactCard;
const CasinoCardWrapper = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(Card, {
    className: "casino-card-wrapper"
  }, children);
};
setGlobal('svs.components.casino_react.CasinoCardWrapper', CasinoCardWrapper);

 })(window);